import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Login: React.FC = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [securityCode, setSecurityCode] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showSecurityCode, setShowSecurityCode] = useState(false);

    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const response = await fetch('/api/auth/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, password, securityCode }),
            });

            if (response.ok) {
                const data = await response.json();
                localStorage.setItem('token', data.token);
                localStorage.setItem('role', data.user.role);
                localStorage.setItem('username', data.user.username);
                navigate('/cil/dashboard');
            } else {
                setError('아이디, 비밀번호 또는 보안 코드가 올바르지 않습니다.');
            }
        } catch (err) {
            setError('서버 연결 중 오류가 발생했습니다.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: '#ffffff',
            fontFamily: '"Pretendard", "Apple SD Gothic Neo", sans-serif'
        }}>
            <div style={{
                background: 'rgba(255, 255, 255, 0.9)',
                backdropFilter: 'blur(10px)',
                padding: '50px 40px',
                borderRadius: '20px',
                boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
                width: '100%',
                maxWidth: '420px',
                border: '1px solid rgba(255, 255, 255, 0.18)'
            }}>
                <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                    <h1 style={{
                        fontSize: '28px',
                        color: '#1a365d',
                        marginBottom: '10px',
                        fontWeight: '700'
                    }}>직원 로그인</h1>
                    <p style={{ color: '#666', fontSize: '14px' }}>천일국제물류 통합 관리 시스템</p>
                </div>

                <form onSubmit={handleLogin}>
                    <div style={{ marginBottom: '20px' }}>
                        <label style={{
                            display: 'block',
                            marginBottom: '8px',
                            fontSize: '13px',
                            color: '#4a5568',
                            fontWeight: '600'
                        }}>아이디</label>
                        <input
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                            style={{
                                width: '100%',
                                padding: '12px 15px',
                                borderRadius: '8px',
                                border: '1px solid #e2e8f0',
                                fontSize: '15px',
                                outline: 'none',
                                transition: 'all 0.2s',
                                backgroundColor: '#fff'
                            }}
                            onFocus={(e) => e.target.style.borderColor = '#3182ce'}
                            onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                        />
                    </div>

                    <div style={{ marginBottom: '20px' }}>
                        <label style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            marginBottom: '8px',
                            fontSize: '13px',
                            color: '#4a5568',
                            fontWeight: '600'
                        }}>
                            <span>비밀번호</span>
                            <span
                                onClick={() => setShowPassword(!showPassword)}
                                style={{
                                    cursor: 'pointer',
                                    color: '#3182ce',
                                    fontSize: '12px'
                                }}
                            >
                                {showPassword ? '숨기기' : '표시'}
                            </span>
                        </label>
                        <input
                            type={showPassword ? "text" : "password"}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            style={{
                                width: '100%',
                                padding: '12px 15px',
                                borderRadius: '8px',
                                border: '1px solid #e2e8f0',
                                fontSize: '15px',
                                outline: 'none',
                                transition: 'all 0.2s',
                                backgroundColor: '#fff'
                            }}
                            onFocus={(e) => e.target.style.borderColor = '#3182ce'}
                            onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                        />
                    </div>

                    <div style={{ marginBottom: '30px' }}>
                        <label style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            marginBottom: '8px',
                            fontSize: '13px',
                            color: '#4a5568',
                            fontWeight: '600'
                        }}>
                            <span>보안 코드</span>
                            <span
                                onClick={() => setShowSecurityCode(!showSecurityCode)}
                                style={{
                                    cursor: 'pointer',
                                    color: '#3182ce',
                                    fontSize: '12px'
                                }}
                            >
                                {showSecurityCode ? '숨기기' : '표시'}
                            </span>
                        </label>
                        <input
                            type={showSecurityCode ? "text" : "password"}
                            value={securityCode}
                            onChange={(e) => setSecurityCode(e.target.value)}
                            required
                            placeholder="할당받은 보안코드를 입력하세요"
                            style={{
                                width: '100%',
                                padding: '12px 15px',
                                borderRadius: '8px',
                                border: '1px solid #e2e8f0',
                                fontSize: '15px',
                                outline: 'none',
                                transition: 'all 0.2s',
                                backgroundColor: '#fff'
                            }}
                            onFocus={(e) => e.target.style.borderColor = '#3182ce'}
                            onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                        />
                    </div>

                    {error && <div style={{
                        color: '#e53e3e',
                        fontSize: '14px',
                        marginBottom: '20px',
                        textAlign: 'center',
                        backgroundColor: '#fff5f5',
                        padding: '10px',
                        borderRadius: '6px'
                    }}>{error}</div>}

                    <button
                        type="submit"
                        disabled={isLoading}
                        style={{
                            width: '100%',
                            padding: '14px',
                            backgroundColor: '#D6A32E', // User preferred gold/yellow tone
                            color: 'white',
                            border: 'none',
                            borderRadius: '8px',
                            fontSize: '16px',
                            fontWeight: '600',
                            cursor: isLoading ? 'wait' : 'pointer',
                            transition: 'background-color 0.2s',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                        }}
                        onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#b58925'}
                        onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#D6A32E'}
                    >
                        {isLoading ? '로그인 중...' : '로그인'}
                    </button>
                </form>

                <div style={{
                    marginTop: '40px',
                    textAlign: 'center',
                    borderTop: '1px solid #eee',
                    paddingTop: '20px'
                }}>
                    <p style={{
                        fontSize: '13px',
                        color: '#888',
                        lineHeight: '1.5',
                        margin: 0
                    }}>
                        본 시스템은 향후<br />
                        <strong style={{ color: '#2d3748' }}>천일국제물류 PS_CRM</strong>으로 통합될 예정입니다.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Login;
